/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createQualitySectionConfig } from '../fn/admin-quality-section-config/create-quality-section-config';
import { CreateQualitySectionConfig$Params } from '../fn/admin-quality-section-config/create-quality-section-config';
import { deleteQualitySectionConfig } from '../fn/admin-quality-section-config/delete-quality-section-config';
import { DeleteQualitySectionConfig$Params } from '../fn/admin-quality-section-config/delete-quality-section-config';
import { QualitySectionConfig } from '../models/quality-section-config';
import { updateQualitySectionConfig } from '../fn/admin-quality-section-config/update-quality-section-config';
import { UpdateQualitySectionConfig$Params } from '../fn/admin-quality-section-config/update-quality-section-config';

@Injectable({ providedIn: 'root' })
export class AdminQualitySectionConfigService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `adminQualitySectionConfigControllerCreateQualitySectionConfig()` */
  static readonly AdminQualitySectionConfigControllerCreateQualitySectionConfigPath = '/admin/quality-section-config';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createQualitySectionConfig()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createQualitySectionConfig$Response(
    params: CreateQualitySectionConfig$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<QualitySectionConfig>> {
    return createQualitySectionConfig(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createQualitySectionConfig$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createQualitySectionConfig(
    params: CreateQualitySectionConfig$Params,
    context?: HttpContext
  ): Observable<QualitySectionConfig> {
    return this.createQualitySectionConfig$Response(params, context).pipe(
      map((r: StrictHttpResponse<QualitySectionConfig>): QualitySectionConfig => r.body)
    );
  }

  /** Path part for operation `adminQualitySectionConfigControllerUpdateQualitySectionConfig()` */
  static readonly AdminQualitySectionConfigControllerUpdateQualitySectionConfigPath =
    '/admin/quality-section-config/{qualitySectionConfigId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateQualitySectionConfig()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateQualitySectionConfig$Response(
    params: UpdateQualitySectionConfig$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<QualitySectionConfig>> {
    return updateQualitySectionConfig(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateQualitySectionConfig$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateQualitySectionConfig(
    params: UpdateQualitySectionConfig$Params,
    context?: HttpContext
  ): Observable<QualitySectionConfig> {
    return this.updateQualitySectionConfig$Response(params, context).pipe(
      map((r: StrictHttpResponse<QualitySectionConfig>): QualitySectionConfig => r.body)
    );
  }

  /** Path part for operation `adminQualitySectionConfigControllerDeleteQualitySectionConfig()` */
  static readonly AdminQualitySectionConfigControllerDeleteQualitySectionConfigPath =
    '/admin/quality-section-config/{qualitySectionConfigId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteQualitySectionConfig()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteQualitySectionConfig$Response(
    params: DeleteQualitySectionConfig$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    return deleteQualitySectionConfig(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteQualitySectionConfig$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteQualitySectionConfig(params: DeleteQualitySectionConfig$Params, context?: HttpContext): Observable<void> {
    return this.deleteQualitySectionConfig$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }
}
